<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>Crear pedido</h2></v-toolbar-title></pre>
                    </v-toolbar>
                    <v-form class="mt-3">
                        <v-col cols="12">
                            <router-link to="lista-pedidos">
                                <v-btn color="red" class="white--text" s>
                                    Volver
                                </v-btn>
                            </router-link>
                        </v-col>
                        <v-row>
                            <v-col cols="8" md="6">
                                <v-autocomplete
                                    label="Contrato"
                                    v-model="pedido.id_contrato"
                                    :items="contratos"
                                    item-text="id"
                                    item-value="id"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="2">
                                <a
                                    target="_blank"
                                    :href="`/api/pdf-contrato/${pedido.id_contrato}`"
                                >
                                    <v-icon
                                        small
                                        class="mr-2"
                                        color="red"
                                        style="font-size: 3rem"
                                        title="PDF"
                                        >mdi-pdf-box</v-icon
                                    >
                                </a>
                            </v-col>
                        </v-row>
                        <h2>Datos de líneas</h2>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    :items="contrato.lineas"
                                    v-model="linea.articulo"
                                    type="text"
                                    label="Artículo"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <div class="spacing">
                                    <v-text-field-comma
                                        v-model="linea.cantidad"
                                        type="number"
                                        label="Cantidad"
                                    >
                                    </v-text-field-comma>
                                </div>
                            </v-col>
                            <v-col cols="12" md="4">
                                <div class="spacing">
                                    <v-text-field-comma
                                        v-model="linea.precio"
                                        type="number"
                                        label="Precio unitario"
                                    >
                                    </v-text-field-comma>
                                </div>
                            </v-col>
                            <v-col cols="12" md="4">
                                <date-select
                                    v-model="linea.fecha"
                                    label="Fecha"
                                >
                                </date-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <div class="spacing">
                                    <v-text-field
                                        v-model="linea.descripcion"
                                        label="Descripción"
                                    >
                                    </v-text-field>
                                </div>
                            </v-col>
                            <v-col cols="12" md="4">
                                <div style="display: flex">
                                    <v-text-field-comma
                                        v-model="linea.dcto"
                                        type="number"
                                        label="Descuento"
                                    >
                                    </v-text-field-comma>
                                    <v-btn-toggle
                                        color="primary"
                                        shaped
                                        v-model="linea.tipo_dcto"
                                        background-color="white"
                                    >
                                        <v-btn text>
                                            <v-icon>mdi-percent</v-icon>
                                        </v-btn>
                                        <v-btn text>
                                            <v-icon>mdi-currency-eur</v-icon>
                                        </v-btn>
                                    </v-btn-toggle>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-btn
                                    @click="addLinea"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    >Añadir</v-btn
                                >
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-data-table
                                    dense
                                    :headers="headers"
                                    hide-default-footer
                                    :items="pedido.lineas"
                                    item-key="id"
                                    class="elevation-1"
                                >
                                    <template v-slot:item.fecha="{ item }">
                                        {{ formatFecha(item.fecha) }}
                                    </template>
                                    <template v-slot:item.cantidad="{ item }">
                                        {{ item.cantidad | decimalComma }}
                                    </template>
                                    <template v-slot:item.precio="{ item }">
                                        {{ item.precio | format_precio }}
                                    </template>
                                    <template v-slot:item.dcto="{ item }">
                                        {{ item.dcto | format_precio }}
                                    </template>
                                    <template v-slot:item.total="{ item }">
                                        {{ item.total | format_precio }}
                                    </template>
                                    <template v-slot:item.dcto_total="{ item }">
                                        {{
                                            CalcularTotalDcto(item)
                                                | format_precio
                                        }}
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <v-icon
                                            @click="openEditDialog(item)"
                                            small
                                            class="mr-2"
                                            color="black"
                                            style="font-size: 25px"
                                            title="EDITAR"
                                            >mdi-pencil-outline</v-icon
                                        >

                                        <v-icon
                                            @click="openDeleteDialog(item)"
                                            small
                                            class="mr-2"
                                            color="red"
                                            style="font-size: 25px"
                                            title="BORRAR"
                                            >mdi-trash-can</v-icon
                                        >
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                        <v-row align="start" justify="end">
                            <v-col cols="8"> </v-col>
                            <v-col cols="12" md="4">
                                <v-card style="min-width: 100%; padding: 1rem">
                                    <v-row>
                                        <v-col cols="6">
                                            <h4>Total:</h4>
                                        </v-col>
                                        <v-col cols="6">
                                            <h4>{{ formatNumber(total) }} €</h4>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-col cols="12">
                            <v-textarea
                                v-model="pedido.observaciones"
                                label="Obersevaciones"
                                outlined
                            >
                            </v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                            <MetodosDePagoSelect
                                v-model="pedido.id_metodo_pago"
                            />
                        </v-col>
                        <v-row>
                            <v-col cols="12">
                                <router-link to="lista-pedidos">
                                    <v-btn color="red" class="white--text" s>
                                        Cancelar
                                    </v-btn>
                                </router-link>
                                <v-btn
                                    v-if="!pedido.id"
                                    @click="savePedido"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    >Guardar</v-btn
                                >
                                <v-btn
                                    v-if="pedido.id"
                                    @click="savePedido"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    >Actualizar</v-btn
                                >
                                <v-btn
                                    v-if="pedido.id"
                                    :disabled="isloading"
                                    color="red"
                                    class="white--text"
                                    >Eliminar</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Editar línea
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field
                                :items="contrato.lineas"
                                v-model="editlinea.articulo"
                                type="text"
                                label="Artículo"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <div class="spacing">
                                <v-text-field-comma
                                    v-model="editlinea.cantidad"
                                    type="number"
                                    label="Cantidad"
                                >
                                </v-text-field-comma>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4">
                            <div class="spacing">
                                <v-text-field-comma
                                    v-model="editlinea.precio"
                                    type="number"
                                    label="Precio unitario"
                                >
                                </v-text-field-comma>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4">
                            <date-select
                                v-model="editlinea.fecha"
                                label="Fecha"
                            >
                            </date-select>
                        </v-col>
                        <v-col cols="12" md="4">
                            <div class="spacing">
                                <v-text-field
                                    v-model="editlinea.descripcion"
                                    label="Descripción"
                                >
                                </v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12">
                            <div style="display: flex">
                                <v-text-field-comma
                                    v-model="editlinea.dcto"
                                    type="number"
                                    label="Descuento"
                                >
                                </v-text-field-comma>
                                <v-btn-toggle
                                    color="primary"
                                    shaped
                                    v-model="editlinea.tipo_dcto"
                                    background-color="white"
                                >
                                    <v-btn text>
                                        <v-icon>mdi-percent</v-icon>
                                    </v-btn>
                                    <v-btn text>
                                        <v-icon>mdi-currency-eur</v-icon>
                                    </v-btn>
                                </v-btn-toggle>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="success" large @click="Edit()"
                        >Modificar</v-btn
                    >

                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--delete dialog-->
        <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="error" large @click="delete_dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteLinea()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import moment from "moment";
import MetodosDePagoSelect from "../../../components/general/MetodosDePagoSelect.vue";
export default {
    components: {
        MetodosDePagoSelect,
    },
    data() {
        return {
            headers: [
                { text: "Artículo", value: "articulo", sortable: false },
                { text: "Descripción", value: "descripcion", sortable: false },
                { text: "Cantidad", value: "cantidad", sortable: false },
                { text: "Fecha", value: "fecha", sortable: false },
                { text: "Precio unidad", value: "precio", sortable: false },
                { text: "Subtotal", value: "subtotal", sortable: false },
                { text: "Descuento", value: "dcto", sortable: false },
                { text: "Total", value: "total", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            metodos_de_pago: [],
            contratos: [],
            menu: false,
            dialog: false,
            delete_dialog: false,
            contrato: { lineas: [] },
            editlinea: {
                total: null,
                id: null,
                fecha: null,
                descripcion: null,
                articulo: null,
                cantidad: null,
                precio: null,
                tipo_dcto: 0,
                dcto: null,
                total: null,
                precio_unidad: null,
            },
            linea: {
                id: null,
                fecha: null,
                descripcion: null,
                articulo: null,
                cantidad: null,
                precio: null,
                tipo_dcto: 0,
                dcto: null,
                total: null,
                precio_unidad: null,
            },
            pedido: {
                id_contrato: null,
                id_metodo_pago: null,
                id: null,
                observaciones: "",
                lineas: [],
            },
        };
    },
    watch: {
        "pedido.id_contrato": function (val) {
            this.getContrato();
            // this.contratos.forEach(element=>{
            //     if(element.id == val && this.pedido.id_metodo_pago == null){
            //         this.pedido.id_metodo_pago = element.id_metodo_pago;
            //     }
            // });
            //this.pedido.lineas = [];
        },
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
    },
    created() {
        this.getContratos();
        if (this.$route.query.id) {
            this.getpedido(this.$route.query.id);
        }
    },
    methods: {
        formatFecha(fecha) {
            let momento = moment(fecha);

            return momento.format("DD-MM-YYYY");
        },
        getpedido(id) {
            let me = this;
            axios.get(`api/get-pedido/${id}`).then(
                (res) => {
                    me.pedido = res.data;
                    me.pedido.lineas = res.data.lineas;
                    //console.log(me.pedido);
                },
                (res) => {}
            );
        },
        savePedido() {
            axios
                .post("api/save-pedido", this.pedido)
                .then((res) => {
                    this.$router.push("lista-pedidos");
                })
                .catch((error) => {
                    //console.log(error.response.status);
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        openEditDialog(item) {
            this.editlinea = JSON.parse(JSON.stringify(item));
            this.editlinea.index = this.pedido.lineas.indexOf(item);
            this.dialog = true;
        },
        Edit() {
            let index = this.editlinea.index;
            let linea = this.getLinea(this.editlinea);
            //console.log(linea);
            this.pedido.lineas[index] = JSON.parse(JSON.stringify(linea));
            this.pedido.lineas = JSON.parse(JSON.stringify(this.pedido.lineas));
            this.dialog = false;
        },
        deleteLinea() {
            let index = this.pedido.lineas.indexOf(this.editlinea);

            this.pedido.lineas.splice(index, 1);
        },
        openDeleteDialog(item) {
            this.editlinea = item;
            this.delete_dialog = true;
        },
        deleteLinea() {
            let index = this.pedido.lineas.indexOf(this.editlinea);

            this.pedido.lineas.splice(index, 1);
        },
        addLinea() {
            let linea = this.getLinea(this.linea);
            this.cleanLinea();
            this.pedido.lineas.push(JSON.parse(JSON.stringify(linea)));
        },
        cleanLinea() {
            this.linea = {
                id: null,
                fecha: null,
                descripcion: null,
                id_producto: null,
                cantidad: null,
                precio: null,
                tipo_dcto: 0,
                dcto: null,
                total: null,
                precio_unidad: null,
            };
        },
        getLinea(linea_l) {
            let linea = linea_l;

            linea.subtotal = linea.precio * linea.cantidad;

            if (linea.tipo_dcto == 0) {
                linea.dcto = (linea.precio * linea.cantidad * linea.dcto) / 100;
                linea.tipo_dcto = 1;
            }

            linea.total = linea.subtotal - linea.dcto;

            return linea;
        },
        getContrato() {
            axios.get(`api/getcontrato/${this.pedido.id_contrato}`).then(
                (res) => {
                    this.contrato = res.data;
                    this.metodos_de_pago = this.contrato.metodos_de_pago;
                    this.pedido.id_metodo_pago = this.contrato.id_metodo_pago;
                    //console.log(this.pedido);
                },
                (err) => {
                    this.$custom_error("Error consultando el contrato");
                }
            );
        },
        getContratos() {
            axios.get(`api/get-contratos`).then(
                (res) => {
                    this.contratos = res.data.Contratos;
                },
                (err) => {
                    this.$custom_error("Error consultando los contratos");
                }
            );
        },
        formatNumber(number) {
            if (number == null) return "null";
            return Number.parseFloat(number.toString())
                .toFixed(2)
                .replace(".", ",")
                .replace(",00", "");
        },
    },
    filters: {},

    computed: {
        total() {
            let total = 0;
            this.pedido.lineas.forEach((elemento) => {
                total += elemento.total;
            });
            this.pedido.total = total;
            return total;
        },
        isloading() {
            return this.$store.getters.getloading;
        },
    },
};
</script>
